import { useEffect } from "react";

import { type UseFormReturn } from "react-hook-form";

import type { ConditionType, MedicationSchema } from "@/models/ConditionModel.ts";

export const useResetInsulinSchemeWhenInvalidDiabetesType = (
  form: UseFormReturn,
  diabetesType: ConditionType | undefined,
  insulinScheme: MedicationSchema | undefined,
) => {
  useEffect(() => {
    if (diabetesType === "gestational" && insulinScheme === "insulinPump") {
      form.setValue("insulinScheme", undefined);
    } else if ((diabetesType === "type1" || diabetesType === "type2") && insulinScheme === "noInsulin") {
      form.setValue("insulinScheme", undefined);
    }
  }, [diabetesType]);
};
